/**
 * This file is used for storing the Images and its path.
 * @exports imagesPath
 * @author {Cognizant Technology Solution}
 */
import question from './images/Question.png';
import hamburger from './images/icon_hamburger.png';
import conversation from './images/icon_conversation.svg';
import dashboard from './images/icon_dashboard.svg';
import reporting from './images/icon_reporting.svg';
import search from './images/icon_search.svg';
import upload from './images/icon_upload.svg';
import cancel from './images/icon_cancel.png';
import errorPage from './images/errorPage.png';
import exportAll from './images/exportAll.png';
import spinner from './images/spinner.svg';
import nikeShoeBox from './images/icon_nikeShoeBox.svg';
import iconBookmark from './images/icon_bookmark.png';
import iconSettings from './images/icon_settings.png';
import iconSire from './images/icon_sire.png';
import Logo from './images/nike_logo.png';
import error from './images/error.png';
import warningGacShoe from './images/warningGacShoe.png';
import gacSettings from './images/icon_gacSettings.png';
import iconXls from './images/icon_xls_file.svg';
import iconPng from './images/icon_file_png.svg';
import iconTxt from './images/icon_file_txt.svg';
import noError from './images/NoError.png';
import processing from './images/Processing.png';
import queued from './images/Queued.png';
import gacError from './images/gacError.png';
import viewError from './images/ViewError.png';
import fileIcon from './images/icon_file.png';
import close from './images/close.png';
import conversationIcon from './images/conversation_icon.svg';
import dpomLogo from './images/dpom_logo.svg';
import nikeBackground from './images/nike_background2.png';
import banner001 from './images/banner001.jpg';
// import banner002 from './images/banner002.jpg';
// import banner003 from './images/banner003.jpg';
// import banner004 from './images/banner004.jpg';
// import banner005 from './images/banner005.jpg';
import conversationThread from './images/conversationThread.png';
import PendingApproval from './images/PendingApproval.png';
import GAC from './images/GAC.png';
import GACUpdate from './images/GACUpdate.png';
import Rejected from './images/rejected.png';
import warningSign from './images/warning_sign.svg';
import ExternalLink from './images/external_Link.png';
import DPOMLOGO from './images/DPOMLOGO.png';
import Layer1 from './images/layer1.png';
import timeout from './images/timeout.svg';
import wrapTextIcon from './images/textWrap.svg';

const imagesPath = {
  timeout: {
    src: timeout,
    alt: 'session Timeout'
  },
  dpomLogo: {
    src: dpomLogo,
    alt: 'Nike Logo'
  },
  poSearchBackground: {
    src: nikeBackground,
    alt: 'PO Search'
  },
  iconHamburger: {
    src: hamburger,
    alt: 'Menu'
  },
  close: {
    src: close,
    alt: 'Close Logo'
  },
  question: {
    src: question,
    alt: 'Question Logo'
  },
  iconConversation: {
    src: conversation,
    alt: 'Conversation'
  },
  iconDashboard: {
    src: dashboard,
    alt: 'Dashboard'
  },
  iconReporting: {
    src: reporting,
    alt: 'Reporting'
  },
  iconSearch: {
    src: search,
    alt: 'POSearch'
  },
  iconUpload: {
    src: upload,
    alt: 'Upload'
  },
  iconCancel: {
    src: cancel,
    alt: 'Cancel'
  },
  iconExportAll: {
    src: exportAll,
    alt: 'Export'
  },
  imgErrorPage: {
    src: errorPage,
    alt: 'ErrorImage'
  },
  imgAvatar: {
    src: '/static/images/avatar/1.jpg',
    alt: 'AvatarImage'
  },
  spinner: {
    src: spinner,
    alt: 'spinner'
  },
  nikeShoeBox: {
    src: nikeShoeBox,
    alt: 'Limit Reached'
  },
  Logo: {
    src: Logo,
    alt: 'Logo'
  },
  error: {
    src: error,
    alt: 'ErrorImage'
  },
  iconBookmark: {
    src: iconBookmark,
    alt: 'iconBookmark'
  },
  iconSettings: {
    src: iconSettings,
    alt: 'iconSettings'
  },
  iconSire: {
    src: iconSire,
    alt: 'iconSire'
  },
  warningGacShoe: {
    src: warningGacShoe,
    alt: 'warningGacShoe'
  },
  gacSettings: {
    src: gacSettings,
    alt: 'gacSettings'
  },
  iconXls: {
    src: iconXls,
    alt: '.xls format'
  },
  iconPng: {
    src: iconPng,
    alt: 'image'
  },
  iconTxt: {
    src: iconTxt,
    alt: 'text format'
  },
  noError: {
    src: noError,
    alt: 'no error'
  },
  processing: {
    src: processing,
    alt: 'processing'
  },
  queued: {
    src: queued,
    alt: 'queued'
  },
  gacError: {
    src: gacError,
    alt: 'GAC Error'
  },
  viewError: {
    src: viewError,
    alt: 'view Error'
  },
  fileIcon: {
    src: fileIcon,
    alt: 'fileIcon Logo'
  },
  conversationIcon: {
    src: conversationIcon,
    alt: 'Conversations'
  },
  bannerDefault: {
    src: banner001,
    alt: 'default banner'
  },
  banner001: {
    src: 'https://n0gsmcommonbusstr01.blob.core.windows.net/dashboard-carousel-images/banner001.jpg?sp=r&st=2025-11-24T14:35:14Z&se=2035-11-24T22:50:14Z&spr=https&sv=2024-11-04&sr=b&sig=JQ1vjLGSRZKFs1OAxJdluxz6%2FAk6kz0XlhBQa5fcksA%3D',
    alt: 'banner001'
  },
  banner002: {
    src: 'https://n0gsmcommonbusstr01.blob.core.windows.net/dashboard-carousel-images/banner002.jpg?sp=r&st=2025-11-24T14:37:34Z&se=2035-11-24T22:52:34Z&spr=https&sv=2024-11-04&sr=b&sig=6GX7lCjvxI1si04305psUCKLLj8VyJk2TJirOQBQyLw%3D',
    alt: 'banner002'
  },
  banner003: {
    src: 'https://n0gsmcommonbusstr01.blob.core.windows.net/dashboard-carousel-images/banner003.jpg?sp=r&st=2025-11-24T14:38:04Z&se=2035-11-24T22:53:04Z&spr=https&sv=2024-11-04&sr=b&sig=MMhowJTXoh8a2LblST5QxJgSmqPC5FODFUmiwW2heBw%3D',
    alt: 'banner003'
  },
  banner004: {
    src: 'https://n0gsmcommonbusstr01.blob.core.windows.net/dashboard-carousel-images/banner004.jpg?sp=r&st=2025-11-24T14:38:31Z&se=2035-11-24T22:53:31Z&spr=https&sv=2024-11-04&sr=b&sig=UsZ5mrKbeWy32Ay66nSwL7yM8e%2F%2BRDguRVMHF2N7qVY%3D',
    alt: 'banner004'
  },
  banner005: {
    src: 'https://n0gsmcommonbusstr01.blob.core.windows.net/dashboard-carousel-images/banner005.jpg?sp=r&st=2025-11-24T14:38:57Z&se=2035-11-24T22:53:57Z&spr=https&sv=2024-11-04&sr=b&sig=QwqyPO8kv1kHoditmeLMs6yKCmGPugrVMTg3OxHq1co%3D',
    alt: 'banner005'
  },
  conversationThread: {
    src: conversationThread,
    alt: 'conversationThread'
  },
  PendingApproval: {
    src: PendingApproval,
    alt: 'PendingApproval'
  },
  GAC: {
    src: GAC,
    alt: 'GAC'
  },
  GACUpdate: {
    src: GACUpdate,
    alt: 'GACUpdate'
  },
  Rejected: {
    src: Rejected,
    alt: 'Rejected'
  },
  warningSign: {
    src: warningSign,
    alt: 'warning'
  },
  ExternalLink: {
    src: ExternalLink,
    alt: 'ExternalLink'
  },
  DPOMLOGO: {
    src: DPOMLOGO,
    alt: 'DPOMLOGO',
    width: 320,
    height: 92
  },
  Layer1: {
    src: Layer1,
    alt: 'Layer1'
  },
  wrapTextIcon: {
    src: wrapTextIcon,
    alt: 'Airfreight Status'
  }
};

export default imagesPath;
